import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import CookieConsent from "@/components/site/CookieConsent";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";
import SmoothScroll from "@/components/site/SmoothScroll";
import { SiteProvider } from "@/lib/site";
import Home from "@/pages/Home";
import Stock from "@/pages/Stock";
import VehicleDetail from "@/pages/VehicleDetail";
import Sell from "@/pages/Sell";
import WeAreBuying from "@/pages/WeAreBuying";
import Standard from "@/pages/Standard";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Servicing from "@/pages/Servicing";
import ThankYou from "@/pages/ThankYou";
import Reserve, { ReserveConfirmation } from "@/pages/Reserve";
import { Legal, NotFound, SeoLanding } from "@/pages/Misc";
import { AuthProvider, RequireAdmin } from "@/admin/auth";
import AdminLogin from "@/admin/AdminLogin";
import { AdminForgotPassword, AdminResetPassword } from "@/admin/AdminPasswordReset";
import AdminLayout from "@/admin/AdminLayout";
import AdminDashboard from "@/admin/AdminDashboard";
import AdminVehicles from "@/admin/AdminVehicles";
import AdminVehicleEditor from "@/admin/AdminVehicleEditor";
import AdminLeads from "@/admin/AdminLeads";
import AdminSettings from "@/admin/AdminSettings";
import AdminInvoices from "@/admin/AdminInvoices";
import AdminPurchases from "@/admin/AdminPurchases";
import AdminSor from "@/admin/AdminSor";
import AdminSales from "@/admin/AdminSales";
import AdminClaims from "@/admin/AdminClaims";

function PublicShell() {
  return (
    <>
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:bg-paper focus:p-3">Skip to content</a>
      <Header />
      <div id="main"><Outlet /></div>
      <Footer />
      <WhatsAppButton />
      <CookieConsent />
    </>
  );
}

export default function App() {
  return (
    <SiteProvider>
      <BrowserRouter>
        <SmoothScroll />
        <Routes>
          <Route element={<PublicShell />}>
            <Route path="/" element={<Home />} />
            <Route path="/stock" element={<Stock />} />
            <Route path="/stock/sold" element={<Stock archive key="archive" />} />
            <Route path="/stock/:slug" element={<VehicleDetail />} />
            <Route path="/used/:slug" element={<SeoLanding />} />
            <Route path="/sell-your-4x4" element={<Sell />} />
            <Route path="/we-are-buying" element={<WeAreBuying />} />
            <Route path="/servicing" element={<Servicing />} />
            <Route path="/the-cirencester-standard" element={<Standard />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/reserve/confirmation/:id" element={<ReserveConfirmation />} />
            <Route path="/reserve/:slug" element={<Reserve />} />
            <Route path="/legal/:page" element={<Legal />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin/*" element={<AuthProvider><AdminRoutes /></AuthProvider>} />
        </Routes>
        <Toaster position="top-center" />
      </BrowserRouter>
    </SiteProvider>
  );
}

function AdminRoutes() {
  return (
    <Routes>
      <Route path="login" element={<AdminLogin />} />
      <Route path="forgot-password" element={<AdminForgotPassword />} />
      <Route path="reset-password" element={<AdminResetPassword />} />
      <Route element={<RequireAdmin><AdminLayout /></RequireAdmin>}>
        <Route index element={<AdminDashboard />} />
        <Route path="vehicles" element={<AdminVehicles />} />
        <Route path="vehicles/:id" element={<AdminVehicleEditor />} />
        <Route path="enquiries" element={<AdminLeads kind="enquiries" />} />
        <Route path="valuations" element={<AdminLeads kind="valuations" />} />
        <Route path="reservations" element={<AdminLeads kind="reservations" />} />
        <Route path="invoices" element={<AdminInvoices />} />
        <Route path="purchases" element={<AdminPurchases />} />
        <Route path="sor" element={<AdminSor />} />
        <Route path="sales" element={<AdminSales />} />
        <Route path="claims" element={<AdminClaims />} />
        <Route path="content" element={<AdminSettings mode="content" />} />
        <Route path="settings" element={<AdminSettings mode="settings" />} />
      </Route>
    </Routes>
  );
}
